// Данные для демо-формы на Стандартизации
import addressHelper from "../../domain/address";
import nameHelper from "../../domain/name";

export default {
    address: {
        name: "Адрес",
        title: "Письма и посылки доходят чаще",
        subtitle:
            "«Дадата» очистит адрес от ошибок, найдет почтовый индекс, координаты, ближайшее метро и другую информацию об адресе",
        placeholder: "адрес в свободной форме",
        defaultValue: "мск сухонска 11/-89",
        icon: "icon-address.svg",

        result: {
            source: "мск сухонска 11/-89",
            result: "г Москва, ул Сухонская, д 11, кв 89",
            postal_code: "127642",
            country: "Россия",
            country_iso_code: "RU",
            federal_district: "Центральный",
            region_fias_id: "0c5b2444-70a0-4932-980c-b4dc0d3f02b5",
            region_kladr_id: "7700000000000",
            region_iso_code: "RU-MOW",
            region_with_type: "г Москва",
            region_type: "г",
            region_type_full: "город",
            region: "Москва",
            area_fias_id: null,
            area_kladr_id: null,
            area_with_type: null,
            area_type: null,
            area_type_full: null,
            area: null,
            city_fias_id: null,
            city_kladr_id: null,
            city_with_type: null,
            city_type: null,
            city_type_full: null,
            city: null,
            city_area: "Северо-восточный",
            city_district_fias_id: null,
            city_district_kladr_id: null,
            city_district_with_type: "р-н Северное Медведково",
            city_district_type: "р-н",
            city_district_type_full: "район",
            city_district: "Северное Медведково",
            settlement_fias_id: null,
            settlement_kladr_id: null,
            settlement_with_type: null,
            settlement_type: null,
            settlement_type_full: null,
            settlement: null,
            street_fias_id: "95dbf7fb-0dd4-4a04-8100-4f6c847564b5",
            street_kladr_id: "77000000000283600",
            street_with_type: "ул Сухонская",
            street_type: "ул",
            street_type_full: "улица",
            street: "Сухонская",
            stead_fias_id: null,
            stead_kladr_id: null,
            stead_with_type: null,
            stead_type: null,
            stead_type_full: null,
            stead: null,
            house_fias_id: "5ee84ac0-eb9a-4b42-b814-2f5f7c27c255",
            house_kladr_id: "7700000000028360004",
            house_cadnum: null,
            house_type: "д",
            house_type_full: "дом",
            house: "11",
            block_type: null,
            block_type_full: null,
            block: null,
            entrance: null,
            floor: null,
            flat_fias_id: "f26b876b-6857-4951-b060-ec6559f04a9a",
            flat_cadnum: "77:02:0004008:4143",
            flat_type: "кв",
            flat_type_full: "квартира",
            flat: "89",
            flat_area: "34.6",
            square_meter_price: "208738",
            flat_price: "7222335",
            postal_box: null,
            fias_id: "f26b876b-6857-4951-b060-ec6559f04a9a",
            fias_code: null,
            fias_level: "9",
            fias_actuality_state: "0",
            kladr_id: "7700000000028360004",
            capital_marker: "0",
            okato: "45280583000",
            oktmo: "45362000",
            tax_office: "7715",
            tax_office_legal: "7715",
            timezone: "UTC+3",
            geo_lat: "55.8782557",
            geo_lon: "37.65372",
            beltway_hit: "IN_MKAD",
            beltway_distance: null,
            qc_geo: 0,
            qc_complete: 0,
            qc_house: 2,
            qc: 0,
            unparsed_parts: null,
            metro: [
                {
                    distance: 1.1,
                    line: "Калужско-Рижская",
                    name: "Бабушкинская",
                },
                {
                    distance: 1.2,
                    line: "Калужско-Рижская",
                    name: "Медведково",
                },
                {
                    distance: 2.5,
                    line: "Калужско-Рижская",
                    name: "Свиблово",
                },
            ],
        },

        resultFields: function (result) {
            if (result.region_type_full == "чувашия") {
                result.region_type_full = "республика";
                result.region = "Чувашия";
            }
            result.gc_geo_name = addressHelper.qcGeoName(result.qc_geo);
            result.qc_complete = addressHelper.inferQcComplete(result);
            result.qc_send_name = addressHelper.qcSendName(result.qc_complete);
            result.iso_codes = addressHelper.isoCodes(result);
            if (result.fias_level) {
                result.fias_level_name = addressHelper.fiasLevel(result);
            }

            if (result.fias_actuality_state) {
                result.fias_actuality_state_name = addressHelper.fiasActualityStateName(
                    result.fias_actuality_state
                );
            }

            result.output_floor = "";
            result.output_floor_arr = [];
            if (result.entrance || result.floor) {
                if (result.entrance) {
                    result.output_floor_arr.push(`${result.entrance}-й подъезд`);
                }
                if (result.floor) {
                    result.output_floor_arr.push(`${result.floor}-й этаж`);
                }
                result.output_floor = result.output_floor_arr.join(", ") + "<br>";
            }

            result.output_area = "";
            result.output_area_arr = [];
            if (result.flat_area || result.flat_price) {
                if (result.flat_area) {
                    result.output_area_arr.push("площадь " + result.flat_area + " м²");
                }
                if (result.flat_price) {
                    const price = new Intl.NumberFormat("ru-RU").format(result.flat_price);
                    result.output_area_arr.push(`стоимость&nbsp;${price} ₽`);
                }
                result.output_area = result.output_area_arr.join(", ") + "<br>";
            }

            const cadnum = addressHelper.cadNum(result);
            if (cadnum) {
                result.output_area += `кадастровый номер ${cadnum}`;
            }

            result.output_house = result.house ? result.house : null;
            if (result.block) {
                result.output_house += " " + result.block_type + " " + result.block;
            }

            const fields = {
                country: "Страна",
                postal_code: "Индекс",
                federal_district: "Фед. округ",
                region: result.region_type_full,
                area: result.area_type_full,
                city: result.city_type_full,
                city_district: "Район",
                settlement: result.settlement_type_full,
                street: result.street_type_full,
                stead: result.stead_type_full,
                output_house: result.house_type_full,
                output_floor: " ",
                flat: result.flat_type_full,
                output_area: " ",
            };

            return fields;
        },

        additionalResultFields: function (result) {
            result.output_geo = null;
            if (result.qc_geo != "5") {
                result.output_geo = result.geo_lat + ", " + result.geo_lon;
                result.output_geo += ` <a href="http://maps.yandex.ru/?text=${result.geo_lat}%2C${result.geo_lon}"
                target="_blank" rel="noreferrer noopener">${result.gc_geo_name}</a>`;
            }

            result.output_beltway_distance = null;
            if (result.beltway_hit) {
                if (result.beltway_distance) {
                    result.output_beltway_distance = result.beltway_distance + "км";
                } else {
                    result.output_beltway_distance = "Внутри кольцевой";
                }
            }

            result.output_metro = "";
            if (result.metro !== null) {
                result.metro.forEach((station) => {
                    result.output_metro += `<div class="metro" data-line="${station.line}">${station.name} (${station.distance} км)</div>`;
                });
            }

            return {
                timezone: "Часовой пояс",
                output_geo: "Геокоординаты",
                output_beltway_distance: "Расстояние от кольцевой",
                output_metro: "Ближайшее метро",
                fias_level_name: "Уровень по ФИАС",
                fias_actuality_state_name: "Актуальность по ФИАС",
                iso_codes: "ISO-код",
                kladr_id: "Код КЛАДР",
                fias_id: "Код ФИАС",
                okato: "Код ОКАТО",
                oktmo: "Код ОКТМО",
                tax_office: "Код ИФНС",
            };
        },

        qc: {
            0: { text: "не требует ручной проверки", isCorrect: true },
            2: { text: "пустой или мусорный", isCorrect: true },
            def: { text: "на ручную проверку", isCorrect: false },
        },

        qc_complete: function (result) {
            return {
                0: { text: "подходит для рассылки", isCorrect: true },
                def: { text: result.qc_send_name, isCorrect: false },
            };
        },
    },
    name: {
        name: "ФИО",
        title: "Клиенты получают «теплые» емейлы",
        subtitle: "Сервис уберет из ФИО ошибки, определит пол и просклоняет",
        placeholder: "ФИО в свободной форме",
        defaultValue: "Срегей владимерович иванов",
        icon: "icon-fullname.svg",

        result: {
            source: "Срегей владимерович иванов",
            result: "Иванов Сергей Владимирович",
            result_genitive: "Иванова Сергея Владимировича",
            result_dative: "Иванову Сергею Владимировичу",
            result_ablative: "Ивановым Сергеем Владимировичем",
            surname: "Иванов",
            name: "Сергей",
            patronymic: "Владимирович",
            gender: "М",
            qc: 1,
        },

        resultFields: function (result) {
            result.qc = nameHelper.isGood(result) ? 0 : 1;

            return {
                surname: "Фамилия",
                name: "Имя",
                patronymic: "Отчество",
                gender: "Пол",
                result: "Им. падеж (кто?)",
                result_genitive: "Род. падеж (кого?)",
                result_dative: "Дат. падеж (кому?)",
                result_ablative: "Твор. падеж (кем?)",
            };
        },

        resultLists: {
            gender: {
                М: "мужской",
                Ж: "женский",
                НД: "не определен",
            },
        },

        qc: {
            0: { text: "не требует ручной проверки", isCorrect: true },
            def: { text: "на ручную проверку", isCorrect: false },
        },
    },
    phone: {
        name: "Телефон",
        title: "Звонки охватывают больше клиентов",
        subtitle:
            "«Дадата» исправит номер, определит оператора и проставит часовой пояс, чтобы&nbsp;не&nbsp;звонить ночами",
        placeholder: "номер телефона",
        defaultValue: "раб 846)231.60.14 *139",
        icon: "icon-phone.svg",

        result: {
            source: "раб 846)231.60.14 *139",
            type: "Стационарный",
            phone: "+7 846 231-60-14 доб. 139",
            country_code: "7",
            city_code: "846",
            number: "2316014",
            extension: "139",
            provider: 'ООО "СИПАУТНЭТ"',
            country: "Россия",
            region: "Самарская область",
            city: "Самара",
            timezone: "UTC+4",
            qc_conflict: 0,
            qc: 0,
        },

        resultFields: function (result) {
            return {
                phone: result.type,
                provider: "Оператор",
                country: "Страна",
                region: "Регион",
                city: "Город",
                timezone: "Часовой пояс",
            };
        },

        qc: {
            0: { text: "не требует ручной проверки", isCorrect: true },
            1: { text: "на ручную проверку", isCorrect: false },
            2: { text: "пустой или мусорный", isCorrect: false },
            3: { text: "несколько телефонов, распознан первый", isCorrect: false },
            7: { text: "иностранный", isCorrect: true },
        },
    },
    email: {
        name: "Емейл",
        title: "Конверсия рассылок увеличивается",
        subtitle:
            "Сервис уберет опечатки в емейлах. Поделит адреса на одноразовые, личные и&nbsp;рабочие",
        placeholder: "адрес эл. почты",
        defaultValue: "serega@yandex/ru",
        icon: "icon-email.svg",

        result: {
            source: "serega@yandex/ru",
            email: "serega@yandex.ru",
            local: "serega",
            domain: "yandex.ru",
            type: "PERSONAL",
            qc: 4,
        },

        resultFields: function () {
            return {
                email: "E-mail",
                type: "Тип",
            };
        },

        resultLists: {
            type: {
                PERSONAL: "личный",
                CORPORATE: "корпоративный",
                ROLE: "ролевой",
                DISPOSABLE: "одноразовый",
            },
        },

        qc: {
            0: { text: "корректный адрес", isCorrect: true },
            1: { text: "на ручную проверку", isCorrect: false },
            2: { text: "пустой или мусорный", isCorrect: false },
            3: { text: "одноразовый адрес", isCorrect: false },
            4: { text: "исправлены опечатки", isCorrect: true },
        },
    },
    passport: {
        name: "Паспорт",
        title: "Подозрительные клиенты выходят на свет",
        subtitle: "«Дадата» проверит паспорт клиента по базе данных МВД",
        placeholder: "номер и серия паспорта",
        defaultValue: "4509 235857",
        icon: "icon-passport.svg",

        result: {
            source: "4509 235857",
            series: "45 09",
            number: "235857",
            qc: 0,
        },

        resultFields: function () {
            return {
                series: "Серия",
                number: "Номер",
            };
        },
        qc: {
            0: { text: "действующий паспорт", isCorrect: true },
            1: { text: "на ручную проверку", isCorrect: false },
            2: { text: "пустой или мусорный", isCorrect: false },
            10: { text: "недействительный паспорт", isCorrect: false },
        },
    },
    vehicle: {
        name: "Автомобиль",
        title: "Порядок в данных",
        subtitle: "«Дадата» определит марку и модель автомобиля из строки",
        placeholder: "марка и модель",
        defaultValue: "ЦРВ Хонда",
        icon: "icon-vehicle.svg",

        result: {
            source: "ЦРВ Хонда",
            brand: "Honda",
            model: "CR-V",
            qc: 0,
        },

        resultFields: function () {
            return {
                brand: "Марка",
                model: "Модель",
            };
        },
        qc: {
            0: { text: "марка и модель", isCorrect: true },
            3: { text: "марка", isCorrect: true },
            1: { text: "на ручную проверку", isCorrect: false },
            2: { text: "пустой или мусорный", isCorrect: false },
        },
    },
};
